module.exports = __webpack_public_path__ + "img/no-results-04-pc.d81ebf4b.webp";